import React from 'react';
export function StartAnytime() {
  return <section className="w-full bg-parchment py-14 md:py-20" data-id="element-182" data-mp="2sy98zcep9tbi">
      <div className="mx-auto w-full max-w-3xl px-5 text-center md:px-8" data-id="element-183" data-mp="35uv20r3bp1e">
        <span className="mx-auto block h-px w-16 bg-gold" aria-hidden="true" data-id="element-184" data-mp="3kdyfjf5q49r9" />
        <h2 className="mt-8 font-serif text-3xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-185" data-mp="3kg2tkpxc6p59">
          ¿Octubre ya comenzó?
          <br data-id="element-186" data-mp="gwg99c5lnasy" />
          <span className="italic text-wine" data-id="element-187" data-mp="gy11gv4fyhnn">No pasa nada.</span>
        </h2>

        <div className="mx-auto mt-7 max-w-xl space-y-3 text-lg leading-relaxed text-muted md:text-xl" data-id="element-188" data-mp="lwm411761df9">
          <p data-id="element-189" data-mp="77put0tdhud2">No necesitas comenzar exactamente el 1 de octubre.</p>
          <p data-id="element-190" data-mp="75c2gzq2uw97">Puedes comenzar hoy y avanzar a tu propio ritmo.</p>
          <p data-id="element-191" data-mp="c4opplkv25cb">
            Lo importante no es haber empezado el primer día.{' '}
            <span className="font-semibold text-ink" data-id="element-192" data-mp="zussjqq86129">Lo importante es comenzar.</span>
          </p>
        </div>

        <p className="mx-auto mt-8 inline-block rounded-2xl bg-ivory px-6 py-4 font-serif text-xl font-semibold text-wine shadow-soft md:text-2xl" data-id="element-193" data-mp="14nc46i5cqm4f">
          El material será tuyo para siempre.
        </p>
      </div>
    </section>;
}